import {DOM} from 'aurelia-framework';
import {kebabCase, camelCase} from 'lodash';

/* Browser features detection tools */

export function kebabCasedStyleProp(prop: string) {
  return supportedProp(prop).kebabCase;
}

export function camelCasedStyleProp(prop: string) {
  return supportedProp(prop).camelCase;
}

type BfdtProp = {
  camelCase: string
  kebabCase: string
}

const vendorsPrefixes = ['webkit', 'moz', 'ms'];
const style = DOM.createElement('div').style;
const propsCache: {[key: string]: BfdtProp} = {};

function vendorsPrefixMap(kebabProp: string): {kebabCase: string[], camelCase: string[]} {
  const list = [kebabProp, ...vendorsPrefixes.map(p => `-${p}-${kebabProp}`)];

  return {
    kebabCase: list,
    camelCase: list.map(v => camelCase(v))
  }
}

function supportedProp(prop: string): BfdtProp {
  const kebabProp = kebabCase(prop);

  if (propsCache[kebabProp]) {
    return propsCache[kebabProp];
  }

  const map = vendorsPrefixMap(prop);
  for (let i = 0, len = map.camelCase.length; i < len; i++) {
    let prop = map.camelCase[i];
    if (style[prop] !== undefined) {
      return propsCache[kebabProp] = {
        camelCase: prop,
        kebabCase: map.kebabCase[i]
      }
    }
  }

  throw 'prop not found';
}
